import type { FaireProductEntity } from "../../entity_types/product";

export const p_c9atxybfmm: FaireProductEntity = {
  token: "p_c9atxybfmm",
  type: "product",
  name: 'Knot Handle Cake Server-12"L-3380',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/c62c1a550600835a2e91c5d5edcaebed0d49e17722501dadee636e6c64291531.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0197cd237319d6a93401ea415c74826399988f99acf0e1a6117da0d5b8f12cec.jpeg",
  ],
  priceDollars: 11,
  description:
    "Our handmade stainless steel KNOT collection add a touch of sophistication to dinner parties of any sort.Packed in a protective Cotton Bag.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:15.655Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
